import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard-tab3',
  templateUrl: './admin-dashboard-tab3.component.html',
  styleUrls: ['./admin-dashboard-tab3.component.scss']
})
export class AdminDashboardTab3Component implements OnInit {
  delegates = ["First Name", "Last Name", "Organisation", "Email", "Clients", "Joined", "Cancelled", "Last log in", "Last edit", "Upload into"];

  rowsDelegates = [
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Sam",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Mickael",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Jonathan",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Wiliam",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Bruce",
      "Last Name" : "Doe",
      "Organisation" : "ABCLTD",
      "Email" : "johndoe@gmail.com",
      "Clients" : "2D",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
